/**
 * Next.js client-side instrumentation — auto-loaded by the browser before any
 * app code runs.
 * https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
 *
 * Starting Bugsnag here wires up window.onerror + unhandledrejection handlers
 * so every uncaught browser error reaches the dashboard. React component
 * errors are surfaced separately via error.tsx boundaries → notifyBoundaryError.
 */
import { startBugsnag } from "@/lib/bugsnag/start"

startBugsnag()
